



















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import NewTicketModal from '@/modules/ticket/components/shared/NewTicketModal.vue'
import { TicketModelType } from '@/modules/ticket/models/ticket-resource.model'

@Component({
  components: { NewTicketModal, BaseButton }
})

export default class NewTicketButton extends Vue {

  @Prop({ default: 'پشتیبانی' }) buttonText!: string
  @Prop({ default: false }) showAsLink!: boolean
  @Prop() itemId!: number
  @Prop() itemType!: TicketModelType

  showModal = false

  get buttonAttrs() {
    const fixedProps = { label: this.buttonText, outline: true }

    if (!this.showAsLink) {
      return {
        ...fixedProps,
        ...this.$attrs
      }
    }

    return {
      ...fixedProps,
      color: 'tes-dark-blue',
      flat: true,
      noHover: true,
      padding: 'none',
      ripple: false,
      ...this.$attrs
    }
  }
}

